interface IProps {
    color?: string;
    size?: number;
    onClick?: () => void;
    stoke?: string;
}

export const EditIcon = (props: IProps) => {
    const { color, size } = props;
    return (
        <svg
            width={size || 12}
            height={size || 12}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.6882 10.014L9.08139 4.33272C9.32015 4.02635 9.40504 3.67215 9.32546 3.31149C9.25648 2.98363 9.05486 2.67189 8.75243 2.43539L8.01493 1.84953C7.37293 1.33892 6.57706 1.39267 6.12076 1.97853L5.62732 2.61867C5.56365 2.69876 5.57957 2.81701 5.65916 2.88151C5.65916 2.88151 6.90602 3.88123 6.93255 3.90273C7.01744 3.98335 7.08111 4.09085 7.09703 4.21985C7.12356 4.47247 6.94846 4.70896 6.68848 4.74121C6.56645 4.75733 6.44972 4.71971 6.36483 4.64984L5.0543 3.60711C4.99063 3.55928 4.89512 3.56949 4.84207 3.63399L1.72757 7.66514C1.52595 7.91775 1.45697 8.24562 1.52595 8.56274L1.92388 10.2881C1.94511 10.3794 2.02469 10.4439 2.1202 10.4439L3.87111 10.4224C4.18945 10.4171 4.48658 10.2719 4.6882 10.014ZM7.13984 9.47663H9.99489C10.2734 9.47663 10.5 9.70613 10.5 9.98831C10.5 10.271 10.2734 10.5 9.99489 10.5H7.13984C6.86129 10.5 6.63473 10.271 6.63473 9.98831C6.63473 9.70613 6.86129 9.47663 7.13984 9.47663Z"
                fill={color || "#676767"}
            />
        </svg>
    );
};
